import { lazy, Suspense } from 'react';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import './App.css';
import '@fontsource/roboto';
const ErrorBoundary = lazy(() => import('./Components/ErrorBoundary'));
const SignIn = lazy(() => import('./Screens/Auth/sign-in'));
const NameInfo = lazy(() => import('./Screens/Auth/name'));
const Personalize = lazy(() => import('./Screens/Auth/personalize'));
const SMSConfirmation = lazy(() => import('./Screens/Auth/confirmation'));
const ErrorScreen = lazy(() => import('./Components/ErrorScreen'));
const RedirectHandler = lazy(() => import("./Components/RedirectHandler"));
const Discover = lazy(() => import('./Screens/Auth/discover'));
const Password = lazy(() => import('./Screens/Auth/password'));
const SetEmail = lazy(() => import('./Screens/Auth/set-email'));
const CardInfo = lazy(() => import('./Screens/Auth/card-info'));
const UpdateProfile = lazy(() => import('./Screens/Auth/update-profile'));

const router = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/login" replace />, // Redirect to login
  },
  {
    path: "/login",
    element: <SignIn />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/redirect",
    element: <RedirectHandler />,
    errorElement: <ErrorScreen />
  },
  {
    path: "/name",
    element: <NameInfo />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/register",
    element: <Personalize />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/sms-confirmation",
    element: <SMSConfirmation />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/location",
    element: <Discover />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/personalize",
    element: <Personalize />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/password",
    element: <Password />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/set-email",
    element: <SetEmail />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/card-info",
    element: <CardInfo />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/update-profile",
    element: <UpdateProfile />,
    errorElement: <ErrorScreen />, // Add custom error element
  },
  {
    path: "/error",
    element: <ErrorScreen />,
  }
]);

function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </Suspense>
  );
}

export default App;
